import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`

  .ReactCollapse--collapse {
    transition: height 300ms ease-in-out;
  }

`
